var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9109 10.0878V19.1287C20.9109 20.113 20.113 20.9109 19.1287 20.9109H4.87129C3.88699 20.9109 3.08911 20.113 3.08911 19.1287V10.0878C3.08911 9.42547 3.78621 8.99453 4.3787 9.29082L11.203 12.703C11.7047 12.9538 12.2953 12.9538 12.797 12.703L19.6213 9.29082C20.2138 8.99453 20.9109 9.42547 20.9109 10.0878ZM5.76238 7.99046V4.87129C5.76238 3.88699 6.56026 3.08911 7.54456 3.08911H16.4554C17.4397 3.08911 18.2376 3.88699 18.2376 4.87129V7.9901L12 11.1089L5.76238 7.99046ZM7.9901 5.76238C7.9901 6.00867 8.18935 6.20792 8.43564 6.20792H15.5644C15.8107 6.20792 16.0099 6.00867 16.0099 5.76238C16.0099 5.51608 15.8107 5.31683 15.5644 5.31683H8.43564C8.18935 5.31683 7.9901 5.51608 7.9901 5.76238ZM7.9901 8.43564C7.9901 8.68194 8.18935 8.88119 8.43564 8.88119H15.5644C15.8107 8.88119 16.0099 8.68194 16.0099 8.43564C16.0099 8.18935 15.8107 7.9901 15.5644 7.9901H8.43564C8.18935 7.9901 7.9901 8.18935 7.9901 8.43564Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlog);
export default __webpack_public_path__ + "static/media/blog.875bd22140d98ac75a1c4a61b88e9a70.svg";
export { ForwardRef as ReactComponent };